
import Logo1 from "../../media/favIcon.png"
import { Icon } from "@iconify/react";
import "../../css/adminnav.css"
import useStore from "../../store/zustandstore";
import user from "../../media/user2.png"
import { useEffect, useRef } from "react";
import usefbStore from "../../store/firebasestore";
import { useNavigate } from "react-router-dom";
function AdminMenu(){

    const showAdminDashboard=useStore((s)=>s.showAdminDashboard)
    const showAiTasks=useStore((s)=>s.showAiTasks)
    const hideAdminDashboard=useStore((s)=>s.hideAdminDashboard)
    const showAiTask=useStore((s)=>s.showAiTask)
    const hideAiTask=useStore((s)=>s.hideAiTask)
    const showJobUpload = useStore((s)=>s.showJobUpload)
    const adminNameRef = useRef(null)
    const adminName = usefbStore((s)=>s.adminName)
    const navigate = useNavigate()
    const showAllUsers = useStore((s)=>s.showAllUsers)

    const toHome =()=>{
        navigate("/")
    }
    const toUsersDrawer =()=>{
        showAllUsers(true)
    }

    const toUploadScreening = ()=>{
        navigate("/admin/upload-quiz")
    }

    useEffect(()=>{
       adminNameRef.current.innerText=adminName
    },[adminName])
    
    const toDash =() =>{
        showAdminDashboard()
    }
    const toJobsUpoad =() =>{
        showJobUpload()
    }
    const toAi =()=>{
        showAiTask()
    }

    return(
        <div className="adminSidemenu">
            <div className="asmLogo">
                <img src={Logo1} alt="" />
            </div>
            <div className="asmLinks">
                <div className="asmlLink" onClick={()=>toDash()}>
                    <div className="asmIcon" >
                           <Icon className="faIcon" icon="solar:armchair-2-linear"/>
                    </div>
                    <p>Dashboard</p>

                </div>
                <div className="asmlLink" onClick={()=>toUsersDrawer()}>
                    <div className="asmIcon">
                        <Icon className="faIcon" icon="solar:user-hand-up-linear"/>
                    </div>
                    <p>Users</p>

                </div>
                
                <div className="asmlLink">
                    <div className="asmIcon">
                        <Icon className="faIcon" icon="solar:library-linear"/>

                    </div>
                    <p>All Jobs</p>

                </div>
                <div className="asmlLink" onClick={()=>toJobsUpoad()}>
                    <div className="asmIcon">
                        <Icon className="faIcon" icon="solar:upload-linear"/>

                    </div>
                    <p>New Job</p>

                </div>
                <div className="asmlLink" onClick={()=>toAi()}>
                    <div className="asmIcon">
                     <Icon className="faIcon" icon="solar:case-round-outline"/>
                    </div>
                    <p>AI Tasks</p>

                </div>
                <div className="asmlLink" onClick={()=>toUploadScreening()}>
                    <div className="asmIcon">
                        <Icon className="faIcon" icon="solar:layers-minimalistic-linear"/>

                    </div>
                    <p>Screening Tasks</p>

                </div>
                <div className="asmlLink" onClick={()=>toHome()}>
                    <div className="asmIcon">
                        <Icon className="faIcon" icon="solar:logout-2-outline"/>

                    </div>
                    <p>Exit</p>

                </div>

            </div>
            <div className="asmAuth">
                <div className="asmAuthBox">
                    <img src={user} alt="" />
                    <div className="asmAuthCont">
                        <p ref={adminNameRef}></p>
                        <span>Administrator</span>
                    </div>
                </div>

            </div>





        </div>
    )
}

export default AdminMenu;